import React from 'react';
import { FileInput, FileItem } from '../../../../../../../ui/components/File';
import { CancelButton, NextButton } from '../../../../../../../ui/components/Button';

interface UnileverImportScanModalFilePaneProps {
  file: File | null;
  setFile: (file: File | null) => void;

  handleClose: () => void;
  handleNext: () => void;
}

export default function UnileverImportScanModalFilePane({
  file,
  setFile,
  handleClose,
  handleNext,
}: UnileverImportScanModalFilePaneProps) {
  const handleUpload = async () => {
    if (!file) return;
    handleNext();
  };

  const handleFiles = (files: FileList | null) => {
    if (!files) return;
    if (!files.length) return;

    setFile(files[0]);
  };

  const handleRemove = () => {
    setFile(null);
  };

  return (
    <div className='flex h-full flex-col justify-between gap-2'>
      <div>
        {!file ? (
          <FileInput onFiles={handleFiles} acceptedTypes='txt' />
        ) : (
          <FileItem file={file} onRemove={handleRemove} />
        )}
      </div>
      <div>
        <div className='flex justify-between'>
          <div></div>
          <div>
            <CancelButton onClick={handleClose} />
            <NextButton disabled={!file} onClick={handleUpload} />
          </div>
        </div>
      </div>
    </div>
  );
}
